import type { AGENT_STEPS } from "../../CustomHooks/customIndustryAgent.types";
import { translateWithFallback } from "./translateWithFallback";

type AgentStep = (typeof AGENT_STEPS)[number];

/** What each graph node is doing, in the order the agent runs them. */
const STEP_LABEL_FALLBACKS: Record<AgentStep, string> = {
    validate_topic: "Checking your description",
    normalize_topic: "Reading your description",
    discover_domains: "Finding candidate websites",
    verify_traffic: "Checking traffic data",
    drop_irrelevant: "Filtering out unrelated websites",
    classify_domains: "Sorting whole sites from segments",
    create_segments: "Building URL segments",
    publish_assets: "Saving the industry",
    warm_overview: "Preparing the overview",
};

/** Shared between the builder's step checklist and the floating banner so the copy never
 *  drifts apart. */
export const getStepLabel = (step: AgentStep): string =>
    translateWithFallback(`market.builder.v2.progress.step.${step}`, STEP_LABEL_FALLBACKS[step]);
